<template>
  <div class="bg-white rounded-lg border border-gray-200 p-4 xl:p-6">
    <h4 v-if="title" class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
      {{ title }}
    </h4>
    <div
      class="overflow-x-auto"
      :style="height ? { height: height, overflowY: 'auto' } : {}"
    >
      <table class="min-w-full table-auto border-collapse">
        <thead>
          <tr class="bg-gray-50">
            <th
              v-for="header in headers"
              :key="header.key"
              class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b"
            >
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr
            v-for="(item, index) in data"
            :key="index"
            class="hover:bg-gray-50"
          >
            <td
              v-for="header in headers"
              :key="header.key"
              class="px-4 py-2 whitespace-nowrap text-xs border-b"
            >
              <!-- Campo con estilo de código -->
              <code v-if="header.isCode" class="field-code">
                {{ getNestedValue(item, header.key) }}
              </code>

              <!-- Pattern con estilo especial -->
              <code
                v-else-if="
                  header.key === 'pattern' && getNestedValue(item, header.key)
                "
                class="pattern-code"
              >
                {{ getNestedValue(item, header.key) }}
              </code>

              <!-- Campo requerido con color -->
              <span
                v-else-if="header.key === 'requerido'"
                :class="
                  getNestedValue(item, header.key) === 'Sí'
                    ? 'text-red-500 font-semibold'
                    : 'text-gray-500'
                "
              >
                {{ getNestedValue(item, header.key) }}
              </span>

              <!-- Valor normal o guión si está vacío -->
              <span v-else>
                {{ getNestedValue(item, header.key) || "-" }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "DynamicTable",
  props: {
    title: {
      type: String,
      default: "",
    },
    headers: {
      type: Array,
      required: true,
      // Formato: [{ key: 'campo', label: 'CAMPO', isCode: true }, ...]
    },
    data: {
      type: Array,
      required: true,
    },
    height: {
      type: String,
      default: null,
      // Ejemplo: "300px", "50vh", "auto"
    },
  },
  methods: {
    getNestedValue(obj, path) {
      return path
        .split(".")
        .reduce((current, key) => current && current[key], obj);
    },
  },
};
</script>

<style scoped>
.field-code {
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 2px 6px;
  font-family: "Courier New", monospace;
  font-size: 12px;
  color: #115700;
  font-weight: 500;
}

.pattern-code {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 1px 4px;
  font-family: "Courier New", monospace;
  font-size: 11px;
  color: #495057;
  font-weight: 400;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .field-code {
    font-size: 10px;
    padding: 1px 4px;
  }

  .pattern-code {
    font-size: 9px;
    padding: 1px 3px;
  }
}
</style>
